var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcNodata = function SvgIcNodata(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.253 7A1.253 1.253 0 0 0 9 8.253v21.044a1.253 1.253 0 0 0 1.253 1.253H16.5a1 1 0 1 1 0 2h-6.247A3.253 3.253 0 0 1 7 29.297V8.253A3.253 3.253 0 0 1 10.253 5h17.284a3.253 3.253 0 0 1 3.253 3.253V16.5a1 1 0 0 1-2 0V8.253A1.253 1.253 0 0 0 27.537 7H10.253Zm3.16 5.013a1 1 0 0 1 1-1h9.364a1 1 0 1 1 0 2h-9.365a1 1 0 0 1-1-1Zm1 4.534a1 1 0 1 0 0 2h5a1 1 0 0 0 0-2h-5ZM25.5 30a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm5.25-.668a6.5 6.5 0 1 0-1.413 1.415l2.96 2.96a1 1 0 1 0 1.415-1.414l-2.961-2.96Z"
  })));
};
export default SvgIcNodata;